function onAccordionTransitionEnter(accordionContent: Element) {
  (accordionContent as HTMLDivElement).style.height = '0px';
  (accordionContent as HTMLDivElement).style.height = accordionContent.scrollHeight + 'px';
}

function onAccordionTransitionLeave(accordionContent: Element) {
  (accordionContent as HTMLDivElement).style.height = accordionContent.scrollHeight + 'px';
}

function onAccordionAfterEnter(accordionContent: Element) {
  (accordionContent as HTMLDivElement).style.height = 'auto';
}

export {
  onAccordionTransitionEnter,
  onAccordionTransitionLeave,
  onAccordionAfterEnter
}
